module.exports = __webpack_public_path__ + "img/Sibiu_3_kl.6e1c49f1.jpg";